import {Injectable} from '@angular/core';
import {UserLoggedRolesServiceService} from './user-logged-roles-service.service';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {environment} from '../../../environments/environment';
import {UserLogged} from '../../models/userLogged';
import {UserLoggedPermissions} from '../../models/userLoggedPermissions';

const suffix = environment.subCookiesDomain;
const LOCAL_STORAGE_USER_NAME = 'currentUser' + suffix;

@Injectable()
export class UserLoggedPermissionsService {

  constructor(
    private userLoggedRolesServiceService: UserLoggedRolesServiceService,
    public utilsService: UtilsService
  ) {
  }

  calculateUserPermissions(responseUser: UserLogged) {
    if (!responseUser) {
      return;
    }
    responseUser.permissions = <UserLoggedPermissions>{};
    this.calculateMckayPermissions(responseUser);
    this.CalculateIsAdminOrSuper(responseUser);
    this.CalculateIsCompanyVendor(responseUser);
    this.CalculateHasNotExpiredNda(responseUser);
    this.CalculateHasNotFormerClientRestrictionsDownloads(responseUser);
    this.CalculateHasNotFormerClientRestrictions(responseUser);
    this.CalculateCanAccessDownloads(responseUser);
    this.CalculateCanAccessHistoricalData(responseUser);
    this.CalculateCanAccessHistoricalDataLog(responseUser);
    this.CalculateCanAccessDownloadsLogs(responseUser);
    this.CalculateCanAccessAnnouncementLog(responseUser);
    this.CalculateCanAccessSymbolDataDownloadLog(responseUser);
    this.CalculateCanAccessRecipients(responseUser);
    this.CalculateCanSeeDownloadsSection(responseUser);
    this.CalculateCanListUsers(responseUser);
    this.CalculateCanManageInvoiceRecipients(responseUser);
    this.CalculateCanAccessLoas(responseUser);
    this.CalculateCanAccessCommercialPops(responseUser);
    this.CalculateCanAccessEncryptionKeys(responseUser);
    this.CalculateCanAccessEncryptionKeysLogs(responseUser);
    this.CalculateCanAccessAuditTrail(responseUser);
    this.CalculateCanSeeUsersSection(responseUser);
    this.CalculateCanListSchedules(responseUser);
    this.CalculateCanListQuincyEtrees(responseUser);
    this.CalculateCanAccessEtreeLedger(responseUser);
    this.CalculateCanSeeBandwidthSection(responseUser);
    this.CalculateCanAccessQedProfile(responseUser);
    this.CalculateCanAccessQfdProfile(responseUser);
    this.CalculateCanAccessQhfProfile(responseUser);
    this.CalculateCanAccessNewsProfile(responseUser);
    this.CalculateCanAccessMonitoringGraphs(responseUser);
    this.CalculateCanAccessAdminEncryptionKeys(responseUser);
    this.CalculateCanAccessDad(responseUser);
    this.CalculateCanAccessSymbolsMulticastData(responseUser);
    this.CalculateCanAccessTimeSyncMonitoring(responseUser);
    this.CalculateCanAccessCryptoMonitoring(responseUser);
    this.CalculateCanSeeQedSection(responseUser);
    this.CalculateCanAccessQrdProfile(responseUser);
    this.CalculateCanAccessProductInformation(responseUser);
    this.CalculateCanSeeQrdSection(responseUser);
    this.CalculateCanSeeQfdSection(responseUser);
    this.CalculateCanSeeQhfSection(responseUser);
    this.CalculateCanSeeMarketDataSection(responseUser);
    this.CalculateCanSeeWeatherMapSection(responseUser);
    this.CalculateCanEditYours(responseUser);
    this.CalculateMustChangePassword(responseUser);
    this.CalculateMustSetupAuthenticator(responseUser);
    this.CalculateIncompleteLogin(responseUser);
    this.CalculateCanEditUsers(responseUser);
    this.CalculateCanAddUser(responseUser);
    this.CalculateConfirmDomainName(responseUser);
    this.CalculateCanAccessQedQrdQfdQhfProfile(responseUser);
    this.CalculateCanAccessTimeSyncProfile(responseUser);
    this.CalculateCanAccessTimeSyncSection(responseUser);
    this.CalculateCanAccessAwsPage(responseUser);
    this.CalculateCanActivateMqttCounters(responseUser);
    this.CalculateCanAccessWorkVisit(responseUser);
    this.utilsService.saveUserData(LOCAL_STORAGE_USER_NAME, responseUser);
  }


  private calculateMckayPermissions(responseUser: UserLogged) {
    responseUser.permissions.isMckayAdminOrMckaySuper = this.userLoggedRolesServiceService.userHasOneOfThoseRoles(responseUser,
      ['ROLE_MCKAY_SUPER', 'ROLE_MCKAY_ADMIN']);
    responseUser.permissions.isMckayAdmin = this.userLoggedRolesServiceService.userHasOneOfThoseRoles(responseUser,
      ['ROLE_MCKAY_ADMIN']);
    responseUser.permissions.isMckaySuper = this.userLoggedRolesServiceService.userHasOneOfThoseRoles(responseUser,
      ['ROLE_MCKAY_SUPER']);
    responseUser.permissions.isMckayUser = this.userLoggedRolesServiceService.userHasOneOfThoseRoles(responseUser,
      ['ROLE_MCKAY']);
  }

  private CalculateIsAdminOrSuper(responseUser: UserLogged) {
    responseUser.permissions.isAdminOrSuperUser = this.userLoggedRolesServiceService.userHasOneOfThoseRoles(responseUser,
      ['ROLE_MCKAY_SUPER', 'ROLE_MCKAY_ADMIN', 'ROLE_CLIENT_SUPER', 'ROLE_CLIENT_ADMIN']);
  }

  private CalculateIsCompanyVendor(responseUser: UserLogged) {
    responseUser.permissions.isCompanyVendor = this.userLoggedRolesServiceService.userHasOneOfThoseRoles(responseUser, ['COMPANY_VENDOR']);
  }

  private CalculateHasNotExpiredNda(responseUser: UserLogged) {
    responseUser.permissions.hasNotExpiredNda = responseUser.access.hasNotExpiredNda;
  }

  private CalculateHasNotFormerClientRestrictionsDownloads(responseUser: UserLogged) {
    responseUser.permissions.hasNotFormerClientRestrictionsDownloads = responseUser.access.hasNotFormerClientRestrictionsDownloads;
  }

  public CalculateHasNotFormerClientRestrictions(responseUser: UserLogged) {
    responseUser.permissions.hasNotFormerClientRestrictions = !responseUser.access.hasFormerClientRestrictions;
  }

  private CalculateCanAccessDownloads(responseUser: UserLogged) {
    responseUser.permissions.canAccessDownloads = responseUser.access.canAccessDownloads;
  }

  private CalculateCanAccessHistoricalData(responseUser: UserLogged) {
    responseUser.permissions.canAccessHistoricalData = responseUser.access.canAccessHistoricalData;
  }

  private CalculateCanAccessHistoricalDataLog(responseUser: UserLogged) {
    responseUser.permissions.canAccessHistoricalDataLog = responseUser.access.canAccessHistoricalDataLog;
  }

  private CalculateCanAccessDownloadsLogs(responseUser: UserLogged) {
    responseUser.permissions.canAccessDownloadsLog = responseUser.permissions.isMckayUser;
  }

  private CalculateCanAccessAnnouncementLog(responseUser: UserLogged) {
    responseUser.permissions.canAccessAnnouncementLog = responseUser.access.canAccessAnnouncementLog;
  }

  private CalculateCanAccessAuditTrail(responseUser: UserLogged) {
    responseUser.permissions.canAccessAuditTrail = responseUser.access.canAccessAuditTrail;
  }

  private CalculateCanAccessSymbolDataDownloadLog(responseUser: UserLogged) {
    responseUser.permissions.canAccessSymbolDataDownloadLog = responseUser.access.canAccessSymbolDataDownloadLog;
  }

  private CalculateCanAccessRecipients(responseUser: UserLogged) {
    responseUser.permissions.canAccessRecipients = responseUser.access.canAccessRecipients;
  }

  private CalculateCanSeeDownloadsSection(responseUser: UserLogged) {
    responseUser.permissions.canSeeDownloadsSection =
      responseUser.permissions.canAccessDownloads
      || responseUser.permissions.canAccessHistoricalData
      || responseUser.permissions.canAccessHistoricalDataLog
      || responseUser.permissions.canAccessDownloadsLog
      || responseUser.permissions.canAccessAnnouncementLog
      || responseUser.permissions.canAccessSymbolDataDownloadLog;
  }

  private CalculateCanListUsers(responseUser: UserLogged) {
    responseUser.permissions.canListUsers = responseUser.access.canListUsers;
  }

  private CalculateCanManageInvoiceRecipients(responseUser: UserLogged) {
    responseUser.permissions.canManageInvoiceRecipients = responseUser.access.canManageInvoiceRecipients;
  }

  private CalculateCanAccessLoas(responseUser: UserLogged) {
    responseUser.permissions.canAccessLoas = responseUser.access.canAccessLoa;
  }

  private CalculateCanAccessCommercialPops(responseUser: UserLogged) {
    responseUser.permissions.canAccessCommercialPops = responseUser.access.canAccessCommercialPops;
  }

  private CalculateCanAccessEncryptionKeys(responseUser: UserLogged) {
    responseUser.permissions.canAccessEncryptionKeys = responseUser.access.canAccessEncryptionKeys;
  }

  private CalculateCanAccessEncryptionKeysLogs(responseUser: UserLogged) {
    responseUser.permissions.canAccessEncryptionKeysLogs = responseUser.access.canAccessEncryptionKeysLogs;
  }

  private CalculateCanSeeUsersSection(responseUser: UserLogged) {
    responseUser.permissions.canSeeUsersSection = responseUser.permissions.canListUsers
      || responseUser.permissions.canAccessLoas
      || responseUser.permissions.canAccessCommercialPops
      || responseUser.permissions.canAccessEncryptionKeys
      || responseUser.permissions.canAccessAuditTrail;
  }

  private CalculateCanListSchedules(responseUser: UserLogged) {
    responseUser.permissions.canListSchedules = responseUser.access.canListSchedules;
  }

  private CalculateCanListQuincyEtrees(responseUser: UserLogged) {
    responseUser.permissions.canListQuincyEtrees = responseUser.access.canListQuincyEtrees;
  }

  private CalculateCanAccessEtreeLedger(responseUser: UserLogged) {
    responseUser.permissions.canAccessEtreeLedger = responseUser.access.canAccessEtreeLedger
      && (responseUser.permissions.isMckayUser || environment.displayClfLedgerForClient);
  }

  private CalculateCanSeeBandwidthSection(responseUser: UserLogged) {
    if (!responseUser.permissions.hasNotFormerClientRestrictions) {
      responseUser.permissions.canSeeBandwidthSection = false;
      return;
    }
    responseUser.permissions.canSeeBandwidthSection =
      responseUser.permissions.canListSchedules
      || responseUser.permissions.canListQuincyEtrees
      || responseUser.permissions.canAccessEtreeLedger
      || responseUser.permissions.canAccessCryptoMonitoring
      || responseUser.permissions.isMckayAdminOrMckaySuper;
  }

  private CalculateCanAccessQedProfile(responseUser: UserLogged): void {
    responseUser.permissions.canAccessQedProfile = responseUser.access.canAccessQedProfile;
  }

  private CalculateCanAccessQfdProfile(responseUser: UserLogged): void {
    responseUser.permissions.canAccessQfdProfile = responseUser.access.canAccessQfdProfile;
  }

  private CalculateCanAccessQhfProfile(responseUser: UserLogged): void {
    responseUser.permissions.canAccessQhfProfile = responseUser.access.canAccessQhfProfile;
  }

  private CalculateCanAccessNewsProfile(responseUser: UserLogged): void {
    responseUser.permissions.canAccessNewsProfile = responseUser.access.canAccessNewsProfile;
  }

  private CalculateCanAccessMonitoringGraphs(responseUser: UserLogged) {
    responseUser.permissions.canAccessHeartbeatPlrGraphs = responseUser.access.canAccessHeartbeatPlrGraphs;
    responseUser.permissions.canAccessPlrLatencyGraphs = responseUser.access.canAccessPlrLatencyGraphs;
    responseUser.permissions.canAccessQrdMlrGraphs = responseUser.access.canAccessQrdMlrGraphs;
    responseUser.permissions.canAccessQrdMlrLatencyGraphs = responseUser.access.canAccessQrdMlrLatencyGraphs;
    responseUser.permissions.canAccessQedMarketDataGraphs = responseUser.access.canAccessQedMarketDataGraphs;
    responseUser.permissions.canAccessQfdMlrLatencyGraphs = responseUser.access.canAccessQfdMlrLatencyGraphs;
    responseUser.permissions.canAccessQhfPlrLatencyGraphs = responseUser.access.canAccessQhfPlrLatencyGraphs;
  }

  private CalculateCanAccessAdminEncryptionKeys(responseUser: UserLogged) {
    responseUser.permissions.canAccessAdminEncryptionKeys = responseUser.access.canAccessEncryptionKeysLogs;
  }

  private CalculateCanAccessDad(responseUser: UserLogged): void {
    responseUser.permissions.canAccessDad = responseUser.access.canAccessDad;
  }

  public CalculateCanAccessSymbolsMulticastData(responseUser: UserLogged): void {
    responseUser.permissions.canAccessSymbolsMulticast = responseUser.access.canAccessSymbolsMulticast;
  }

  public CalculateCanAccessTimeSyncMonitoring(responseUser: UserLogged): void {
    responseUser.permissions.canAccessTimeSyncMonitoring = responseUser.access.canAccessTimeSyncMonitoring;
  }

  public CalculateCanAccessCryptoMonitoring(responseUser: UserLogged): void {
    responseUser.permissions.canAccessCryptoMonitoring = responseUser.access.canAccessCryptoMonitoring;
  }

  private CalculateCanSeeQedSection(responseUser: UserLogged) {
    responseUser.permissions.canSeeQedSection = responseUser.permissions.canAccessQedProfile
      || responseUser.permissions.canAccessHeartbeatPlrGraphs
      || responseUser.permissions.canAccessPlrLatencyGraphs
      || responseUser.permissions.canAccessAdminEncryptionKeys
      || responseUser.permissions.canAccessDad
      || responseUser.permissions.canAccessTimeSyncMonitoring
      || responseUser.permissions.canAccessSymbolsMulticast;
  }

  private CalculateCanAccessQrdProfile(responseUser: UserLogged): void {
    responseUser.permissions.canAccessQrdProfile = responseUser.access.canAccessQrdProfile;
  }

  public CalculateCanAccessProductInformation(responseUser: UserLogged): void {
    responseUser.permissions.canAccessProductInformation = responseUser.access.canAccessProductInformation;
  }

  private CalculateCanSeeQrdSection(responseUser: UserLogged) {
    responseUser.permissions.canSeeQrdSection = responseUser.permissions.canAccessQrdProfile
      || responseUser.permissions.canAccessQrdMlrGraphs
      || responseUser.permissions.canAccessQrdMlrLatencyGraphs
      || responseUser.permissions.canAccessProductInformation
      || responseUser.permissions.canAccessSymbolsMulticast;
  }

  private CalculateCanSeeQfdSection(responseUser: UserLogged) {
    responseUser.permissions.canSeeQfdSection =
      (!responseUser.permissions.isMckayUser && responseUser.permissions.canAccessQfdProfile)
      || responseUser.permissions.canAccessQfdMlrLatencyGraphs;
  }

  private CalculateCanSeeQhfSection(responseUser: UserLogged) {
    responseUser.permissions.canSeeQhfSection = responseUser.permissions.canAccessQhfProfile || responseUser.permissions.canAccessQhfPlrLatencyGraphs;
  }

  private CalculateCanSeeMarketDataSection(responseUser: UserLogged) {
    responseUser.permissions.canSeeMarketDataSection =
      responseUser.permissions.canSeeQedSection
      || responseUser.permissions.canSeeQrdSection
      || responseUser.permissions.canSeeQfdSection
      || responseUser.permissions.canSeeQhfSection
      || responseUser.permissions.canAccessNewsProfile;
  }

  private CalculateCanSeeWeatherMapSection(responseUser: UserLogged) {
    responseUser.permissions.canSeeWeatherMapSection = !responseUser.permissions.isCompanyVendor && !responseUser.company.timeSyncOnly
      && responseUser.permissions.hasNotFormerClientRestrictions;
  }

  private CalculateCanEditYours(responseUser: UserLogged): void {
    responseUser.permissions.canEditYours = responseUser.access.canEditYours;
  }

  private CalculateMustChangePassword(responseUser: UserLogged) {
    responseUser.permissions.mustChangePassword = this.userLoggedRolesServiceService.userHasOneOfThoseRoles(responseUser,
      ['MCKAY_FIRST_LOGIN', 'USER_FIRST_LOGIN']);
  }

  private CalculateMustSetupAuthenticator(responseUser: UserLogged) {
    responseUser.permissions.mustSetupAuthenticator = this.userLoggedRolesServiceService.userHasOneOfThoseRoles(responseUser, ['MUST_CONNECT_MFA'])
      && environment.mfaMethod === 'google_authenticator';
  }

  private CalculateIncompleteLogin(responseUser: UserLogged) {
    responseUser.permissions.incompleteLogin = this.userLoggedRolesServiceService.userHasOneOfThoseRoles(responseUser, ['ROLE_INCOMPLETE_LOGIN']);
  }

  private CalculateCanEditUsers(responseUser: UserLogged) {
    responseUser.permissions.canEditUsers = responseUser.access.canEditUsers;
  }

  private CalculateCanAddUser(responseUser: UserLogged) {
    responseUser.permissions.canAddUsers = responseUser.access.canAddUsers;
  }

  private CalculateConfirmDomainName(responseUser: UserLogged) {
    responseUser.permissions.canConfirmDomainName = responseUser.access.canConfirmDomainName;
  }

  private CalculateCanAccessQedQrdQfdQhfProfile(responseUser: UserLogged): void {
    responseUser.permissions.canAccessQedQrdQfdProfile = responseUser.access.canAccessQedProfile
      || responseUser.access.canAccessQrdProfile
      || responseUser.access.canAccessQfdProfile
      || responseUser.access.canAccessQhfProfile
      || responseUser.access.canAccessNewsProfile;
  }

  private CalculateCanAccessTimeSyncProfile(responseUser: UserLogged): void {
    responseUser.permissions.canAccessTimeSyncProfile = responseUser.access.canAccessTimeSyncProfile;
  }

  private CalculateCanAccessTimeSyncSection(responseUser: UserLogged): void {
    responseUser.permissions.canAccessTimeSyncSection =
      (!responseUser.permissions.isMckayUser && responseUser.permissions.canAccessTimeSyncProfile) || responseUser.permissions.canAccessTimeSyncMonitoring;
  }

  public userHasOneOfThosePermissions(user: UserLogged, permissionsNames: string[]): boolean {
    if (!user || !user.permissions) {
      return false;
    }
    for (const permissionName of permissionsNames) {
      if (user.permissions[permissionName] && user.permissions[permissionName] === true) {
        return true;
      }
    }
    return false;
  }

  public userHasAllOfThosePermissions(user: UserLogged, permissionsNames: string[]): boolean {
    if (!user || !user.permissions) {
      return false;
    }
    for (const permissionName of permissionsNames) {
      if (!user.permissions[permissionName]) {
        return false;
      }
    }
    return true;
  }

  private CalculateCanAccessAwsPage(responseUser: UserLogged) {
    responseUser.permissions.canAccessAwsPage = responseUser.access.canAccessAwsPage;
  }

  private CalculateCanActivateMqttCounters(responseUser: UserLogged) {
    responseUser.permissions.canActivateMqttCounters = responseUser.access.canActivateMqttCounters;
  }

  private CalculateCanAccessWorkVisit(responseUser: UserLogged) {
    responseUser.permissions.canAccessWorkVisit = responseUser.access.canAccessWorkVisit;
  }
}



